import publicV2Api from '../../../api/publicV2.js'

export default {
  uploadImage: (payload, callback) => {
    const formData = payload.formData;
    publicV2Api.post('/cloudflare/permanentFile', formData, (error, responseData) => {
      if (error) return callback(error, null);
      callback(null, responseData);
    });
  }
} 